module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-primary navbar-transparent- navbar-absolute"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse"
    },
    on: {
      "click": _vm.toggleSideBar
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _c('span', {
    staticClass: "icon-bar"
  }), _c('span', {
    staticClass: "icon-bar"
  }), _c('span', {
    staticClass: "icon-bar"
  })]), _c('a', {
    staticClass: "navbar-brand logo",
    attrs: {
      "href": "#/home"
    }
  }, [(!_vm.config.namespace) ? _c('img', {
    attrs: {
      "src": require("images/../logo.svg"),
      "height": "35"
    }
  }) : _vm._e(), (_vm.config.title) ? _c('p', [_vm._v(_vm._s(_vm.$t(_vm.config.title)))]) : _vm._e()])]), _c('div', {
    staticClass: "collapse navbar-collapse text-right"
  }, [_c('site-map')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cdbb6f6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation/index.vue
// module id = kmwP
// module chunks = 13 14